import {powerPage,powerData} from "../../public/power.js"
var scharr = ["无", "个人", "学科", "校区", "全部"]
var libarr = ["无", "个人-授权科目", "校区-授权科目", "全部-授权科目", "个人-所有科目", "校区-所有科目", "全部-所有科目"]
export default {
	namespaced: true,
	state: ()=>({
		user:null,
		pagePower:null,
		dataPower:null,
		baseData:null,
	}),
	getters:{
		getuser(state){
			if(!state.user){
				state.user=JSON.parse(sessionStorage.getItem("user"))
			}
			return state.user
		},
		getPagePower:(state)=>(str)=>{
			if(!state.pagePower){
				state.pagePower=JSON.parse(sessionStorage.getItem("pagePower"))
			}
			let arr = str.split("/")
			if(arr[0]==="资源库"){
				return true
			}
			for(let i=0;i<arr.length;i++){
				if(!state.pagePower[powerPage[arr[i]]]){
					return false
				}
			}
			return true
		},
		getDataPower:(state)=>(str)=>{
			if(!state.dataPower){
				state.dataPower=JSON.parse(sessionStorage.getItem("dataPower"))
			}
			let dp = state.dataPower[powerData[str]]
			let dpstr=""
			dpstr= scharr[dp]
			if(str==="试题下载"||str==="试题上传"){
				dpstr= libarr[dp]
			}
			let obj={
				dp:dpstr,
			}
			if(!state.user){
				state.user=JSON.parse(sessionStorage.getItem("user"))
			}
			if(!state.baseData){
				state.baseData=JSON.parse(sessionStorage.getItem("baseData"))
			}
			let dparr=dpstr.split("-")
			switch(dparr[0]){
			case "个人":
				obj.sch=state.user.sch
				obj.job=state.user.job
				obj.sub=[state.user.sub]
				obj.dj=[state.user.dj]
				break
			case "学科":
				obj.sch=state.baseData.allSch
				obj.job=state.baseData.allJob
				obj.sub=[state.user.sub]
				obj.dj=state.baseData.allDj
				break
			case "校区":
				obj.sch=state.user.sch
				obj.job=state.baseData.allJob
				obj.sub=state.baseData.allSub
				obj.dj=state.baseData.allDj
				break
			case "全部":
				obj.sch=state.baseData.allSch
				obj.job=state.baseData.allJob
				obj.sub=state.baseData.allSub
				obj.dj=state.baseData.allDj
				break
			// case "主要科目":
			// 	obj.sch=state.user.sch
			// 	obj.sub=[state.user.sub]
			// 	break
			// case "权限科目":
			// 	obj.sch=state.user.sch
			// 	obj.sub=state.baseData.testSub
			// 	break
			default:
				obj.sch=[]
				obj.job=[]
				obj.sub=[]
				obj.dj=[]
			}
			if(dparr[1]){
				switch(dparr[1]){
				case "授权科目":
					obj.sub=state.baseData.testSub
					break
				case "所有科目":
					obj.sub=state.baseData.allSub
					break
				}
			}
			return obj
		}
	},
	mutations: {
		setUser(state,user){
			state.user=user
			sessionStorage.setItem('user',JSON.stringify(user))
		},
		setPagePowert(state,data){
			state.pagePower=data
			sessionStorage.setItem("pagePower",JSON.stringify(data))
		},
		setDataPower(state,data){
			state.dataPower=data
			sessionStorage.setItem("dataPower",JSON.stringify(data))
		},
		setBaseData(state,data){
			state.baseData=data
			sessionStorage.setItem("baseData",JSON.stringify(data))
		},
	}
}
